export default __webpack_public_path__ + "static/media/mobile-alert-off.03649643.svg";